.flip-graph{width:100%!important;height:auto!important;max-height:400px;flex:0 0 auto;overflow:hidden}
/*# sourceMappingURL=flip-overview-graph.component-3CMRC3RE.css.map */
